var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 617 207",
    width: 617,
    height: 207,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffcc00;stroke: #000000;stroke-width: 0 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m451.6 153.3c9.1-0.2 16-2.6 21-7.4 5.4-5 8.2-13.2 9.3-21.4 1-8.5-0.8-20.7-3.6-27.9-2.7-7.1-7-11.1-12.6-14.6-5.4-3.6-11.7-5.6-20.1-6.7-8.4-1.3-18.5-1.6-30.3-0.7l3-10.1c13.5-1.4 25.2-1.2 35.4 1 10.4 2.1 18.9 5.8 25.8 12 7 6.4 13 16 15.6 25.6 2.7 9.6 3 21.3 0.3 31.1-2.5 9.5-6.2 19.6-15.6 25.6-9.3 5.8-22.3 9-39.6 9.4 3.8-5.3 7.6-10.6 11.4-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m616 69.1c0 6.1-1.9 11.8-6.3 17.8h-11.4l-2.7-4.9c-5 0.1-9.2-0.2-12.6-0.3-3.5-0.4-5.7-0.4-8.1-1.3-2.3-0.9-4.2-2.4-5.7-4.2-15.2 1.1-25.2 0.6-30.3-1.6-5.2-2.3-5.2-9.5-0.4-11.7 5.1-2.2 15.1-2.8 30.3-1.6 1.6-1.9 3.5-3.3 5.8-4.2 2.3-0.9 4.6-1.1 8-1.3 3.5-0.3 7.6-0.4 12.7-0.3l2.6-4.9h11.5c4.4 6.4 6.5 12.3 6.6 18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m188.9 134.2h115.4v14.9h-115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m188.9 157.2h115.4v14.9h-115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m181 149.4c-2-0.4-3.7-0.5-5.2-0.2-1.4 0.2-3 0.7-3.8 1.7-0.6 0.8-0.7 2.9-0.4 3.9 0.5 0.8 1.4 1.5 2.9 1.9 1.5 0.3 3.6 0.5 6 0.4l1.1 15.2c-3.6 0-6.8-0.2-9.7-0.9-2.9-0.8-5.4-2-7.5-3.5-1.7-1.8-2.9-3.7-3.8-6.4-0.8-2.8-1.2-6.9-1.2-10 0.4-3.2 1.2-6 2.4-8.3 1.2-2.4 2.8-4.2 4.6-5.7 1.9-1.4 4.4-2.4 6.5-2.9 2.2-0.6 4.4-0.7 6.6-0.3q0.8 7.6 1.5 15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m189.8 133.6c0 0-1.3 4.2-0.9 8.3 0.5 4 2.6 8 2.6 8h-12c-1.1-1-1.8-2.5-2.4-4.6-0.3-2.1-0.7-5.6-0.5-7.5 0.3-2.1 1-3.4 2.1-4.3 3.7 0 7.4 0.1 11.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m189.8 156.7c0 0-1.3 4.1-0.9 8.2 0.5 4.1 2.6 8.1 2.6 8.1h-12c-1.1-1-1.8-2.6-2.4-4.6-0.3-2.1-0.7-5.6-0.5-7.6 0.3-2 1-3.4 2.1-4.3q5.6 0.1 11.1 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m214.3 131h68.4v1.9h-68.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m216.4 128h12.9v6.9h-12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m221.3 123.8h3.1v4.4h-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m218.4 122.5h8.7v2h-8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m170.6 170.7l-2.3 3q1.3 1.1 1.9 1.9c0.4 0.6 0.6 1.1 0.5 1.5-0.8 0.7-1.7 1.3-2.4 1.9-0.7 0.6-1.7 1.2-2.4 1.4-0.6 0.1-1.2-0.2-1.6-0.9-1.4 0.2-3.1-0.3-5.2-1.3-2.1-1-4.7-2.2-7.1-4.6-2.1-2.6-4.2-6.1-6.1-10.5-1.9-0.3-2.7-1.1-3-1.8 0-1 0.5-1.9 2-3.2-0.5-3.2-0.2-6.4 1-9.8 1.4-3.5 5.5-10.1 6.3-10.8 0.8-0.9-0.9 3.5-1.7 6-0.6 2.4-1.4 6.1-1.8 8.7q-0.3 3.7 0.6 6.3l10.6-2.1 1.3 4.9-10.2 2c0.4 2.8 1.2 5 2.5 6.9 1.3 1.8 3 3 5.1 4-0.2-0.6 0-1.3 0.3-1.8 0.3-0.7 1.5-1.2 2-1.4 0.7-0.2 1.3-0.3 1.9 0.2l2.8-3c0.4 0.3 1 0.6 1.8 1q1.3 0.6 3.2 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m206.3 177.1h60.3v1.9h-60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m209.9 171.1h7.3v11.1h-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m264.2 174.3h3.6v8.3h-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m259.5 174.4h3.1v8.3h-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m220.1 171.1h7.3v11.1h-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m370.9 23.9v6.5l-5.3 0.5v15c1.8 0 3.1 0.3 4.6 0.7 1.5 0.4 2.7 1.1 3.8 1.9v7.5l-0.9 1.1c0 2.8 0 15.4 0 38.6 0 23.2 0 55.9 0 99.6l1.6 0.6v7.6c-0.3 0.6-1.3 1.3-2.8 1.7-1.5 0.4-4 0.9-6.1 1.1-2 0.1-3.6 0.2-5.4 0q-3.9-0.5-6.2-1.2c-1.5-0.4-2.4-1.1-2.8-1.7v-7.6l1.7-0.6c0-43.8 0-76.3 0-99.6 0-23.2 0-35.8 0-38.6l-1-1.1v-7.5c1.2-0.8 2.5-1.4 3.8-1.8 1.6-0.5 2.9-0.7 4.6-0.8v-14.8l-5.2-0.7v-6.5c1.6-0.5 3.4-0.8 5.2-0.9 2-0.1 4.3-0.1 6 0.2 1.7 0.1 3.2 0.4 4.4 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m372.4 55.1h-0.3v-5.3h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m370.4 55.5h-0.3v-5.3h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m368.7 55.6h-0.3v-5.3h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m365.9 56h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m363.4 56h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m360.8 55.8h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m358.1 55.3h-0.2v-5.3h0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m355.5 54.9h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m367 29c-1.6 0.4-4.8 0.2-6.6 0.2-1.8 0-3.2-0.2-4.1-0.4v-2c4.4 0.2 7.4 0.3 9.7 0.3 2.3 0 3.5-0.4 3.8-0.6-0.3 1.2-1.2 2-2.8 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m363.1 33.1c0.2 1.7 0.2 9.2 0 10.9 0 1.6-0.3 0.8-0.6-0.9-0.1-1.8-0.3-7.9-0.3-9.5 0.1-1.7 0.8-2.3 0.9-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m360.7 66.7c0.3 0.3 0.6 10.5 0.4 18 0 7.4-0.1 25-0.9 26.3-0.8 0.9-3.4-13.2-4-19.5-0.4-6.3 0.6-18.7 0.9-18 0.3 0.7 0.6 20.5 0.9 22.2 0.7 1.3 1.6-8 2-12.9 0.6-4.9 0.6-16.4 0.7-16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m372.8 202.7h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m370.4 203.5h-0.3v-5.3h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m367.7 204.2h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m364.9 204.4h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m361.7 204.5h-0.2v-5.4h0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m358.7 204.4h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m356 204h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m353.7 203h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m342.8 23.9v6.5l-5.3 0.5v15c1.8 0 3.2 0.3 4.6 0.7 1.5 0.4 2.8 1.1 3.9 1.9v7.5l-1 1.1c0.1 2.8 0.1 15.4 0 38.6 0.1 23.2 0.1 55.9 0 99.6l1.7 0.6v7.6c-0.3 0.6-1.4 1.3-2.8 1.7-1.6 0.4-4.1 0.9-6.1 1.1-2 0.1-3.6 0.2-5.5 0q-3.8-0.5-6.1-1.2c-1.5-0.4-2.4-1.1-2.8-1.7v-7.6l1.6-0.6c0.1-43.8 0.1-76.3 0-99.6 0.1-23.2 0.1-35.8 0-38.6l-0.9-1.1v-7.5c1.1-0.8 2.4-1.4 3.8-1.8 1.5-0.5 2.9-0.7 4.6-0.8v-14.8l-5.3-0.7v-6.5c1.6-0.5 3.5-0.8 5.3-0.9 1.9-0.1 4.2-0.1 5.9 0.2 1.8 0.1 3.2 0.4 4.4 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m344.4 55.1h-0.3v-5.3h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m342.3 55.5h-0.3v-5.3h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m340.6 55.6h-0.3v-5.3h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m337.9 56h-0.4v-5.4h0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m335.4 56h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m332.8 55.8h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m330.1 55.3h-0.3v-5.3h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m327.4 54.9h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m338.9 29c-1.5 0.4-4.7 0.2-6.6 0.2-1.7 0-3.1-0.2-4-0.4v-2c4.3 0.2 7.3 0.3 9.7 0.3 2.2 0 3.4-0.4 3.7-0.6-0.3 1.2-1.1 2-2.8 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m335.1 33.1c0.2 1.7 0.2 9.2 0 10.9-0.1 1.6-0.4 0.8-0.6-0.9-0.2-1.8-0.4-7.9-0.4-9.5 0.2-1.7 0.9-2.3 1-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m332.7 66.7c0.2 0.3 0.4 10.5 0.3 18 0 7.4-0.1 25-0.9 26.3-0.8 0.9-3.3-13.2-3.9-19.5-0.5-6.3 0.6-18.7 0.8-18 0.3 0.7 0.6 20.5 1 22.2 0.6 1.3 1.5-8 2-12.9 0.5-4.9 0.5-16.4 0.7-16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m344.7 202.7h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m342.3 203.5h-0.3v-5.3h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m339.6 204.2h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m336.9 204.4h-0.4v-5.4h0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m333.7 204.5h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m330.6 204.4h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m327.9 204h-0.2v-5.4h0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m325.6 203h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m316.5 23.9v6.5l-5.2 0.5v15c1.7 0 3.1 0.3 4.6 0.7 1.4 0.4 2.7 1.1 3.8 1.9v7.5l-1 1.1c0.1 2.8 0.1 15.4 0 38.6 0.1 23.2 0.1 55.9 0 99.6l1.7 0.6v7.6c-0.4 0.6-1.3 1.3-2.8 1.7-1.5 0.4-4.2 0.9-6.2 1.1-1.9 0.1-3.7 0.2-5.4 0-2.7-0.4-4.5-0.8-6.1-1.2-1.4-0.4-2.5-1.1-2.8-1.7v-7.6l1.6-0.6c0-43.8 0-76.3 0-99.6 0-23.2 0-35.8 0-38.6l-1-1.1v-7.5c1.2-0.8 2.5-1.4 3.9-1.8 1.5-0.5 2.8-0.7 4.6-0.8v-14.8l-5.3-0.7v-6.5c1.7-0.5 3.4-0.8 5.3-0.9 2.1-0.1 4.1-0.1 5.9 0.2 1.8 0.1 3.3 0.4 4.4 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m318 55.1h-0.2v-5.3h0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m316 55.5h-0.2v-5.3h0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m314.3 55.6h-0.3v-5.3h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m311.5 56h-0.2v-5.4h0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m309.1 56h-0.4v-5.4h0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m306.5 55.8h-0.4v-5.4h0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m303.8 55.3h-0.3v-5.3h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m301.1 54.9h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m312.6 29c-1.6 0.4-4.8 0.2-6.6 0.2-1.8 0-3.1-0.2-4-0.4v-2c4.2 0.2 7.4 0.3 9.6 0.3 2.3 0 3.5-0.4 3.8-0.6-0.3 1.2-1.2 2-2.8 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m308.8 33.1c0.1 1.7 0.1 9.2-0.1 10.9 0 1.6-0.2 0.8-0.5-0.9-0.2-1.8-0.3-7.9-0.4-9.5 0.1-1.7 0.9-2.3 0.9-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m306.4 66.7c0.3 0.3 0.4 10.5 0.3 18 0 7.4-0.1 25-0.9 26.3-0.7 0.9-3.3-13.2-3.9-19.5-0.5-6.3 0.6-18.7 0.8-18 0.3 0.7 0.6 20.5 1 22.2 0.6 1.3 1.5-8 2-12.9 0.5-4.9 0.5-16.4 0.7-16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m318.4 202.7h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m316 203.5h-0.3v-5.3h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m313.3 204.2h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m310.5 204.4h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m307.4 204.5h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m304.3 204.4h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m301.6 204h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m299.3 203h-0.3v-5.4h0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m325.2 121.9c0.9 0.4 1.5 1 2.1 2 0.7 0.8 1.6 2 1.4 3.5-0.2 1.5-0.8 3.4-2.3 5.5-0.6-0.7-1.3-1.4-2.3-1.6-0.9-0.5-2-0.7-3.2-0.4-1.3 0.2-2.7 0.7-4.3 1.7-1.2-1.9-1.7-3.6-1.5-5.4 0.2-1.9 1.3-3.7 3-5.5 0.2 1.4 0.9 2.5 1.7 2.9 0.9 0.5 2.9 0 3.8-0.2 0.8-0.6 1.5-1.2 1.6-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m352.7 122.5c0.8 0.4 1.6 1 2.1 1.9 0.7 0.8 1.5 2.1 1.3 3.5-0.1 1.5-0.9 3.4-2.3 5.6-0.5-0.8-1.3-1.4-2.2-1.7-0.9-0.4-2-0.6-3.3-0.4-1.2 0.3-2.6 0.8-4.2 1.7-1.4-1.8-1.8-3.5-1.6-5.4 0.3-1.8 1.2-3.7 3.1-5.4 0.3 1.5 0.7 2.3 1.7 2.9 0.9 0.3 2.9 0.2 3.7-0.3 0.9-0.5 1.6-1.2 1.7-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m326.1 181.6c0.8 0.4 1.6 1 2.1 2 0.7 0.8 1.5 2 1.3 3.5-0.1 1.5-0.9 3.4-2.3 5.6-0.5-0.8-1.3-1.5-2.2-1.7-0.9-0.5-2-0.7-3.3-0.4-1.2 0.1-2.7 0.7-4.3 1.6q-1.8-2.7-1.5-5.3c0.2-1.9 1.4-3.7 3.1-5.5 0.2 1.4 0.9 2.5 1.7 2.9 1 0.5 2.8 0 3.7-0.2 0.8-0.5 1.5-1.2 1.7-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m353.1 181.3c0.9 0.4 1.5 1 2.1 2 0.7 0.8 1.6 2 1.4 3.5-0.2 1.4-0.9 3.4-2.3 5.5-0.6-0.7-1.4-1.4-2.3-1.7-0.9-0.4-2-0.6-3.3-0.4-1.2 0.2-2.6 0.7-4.2 1.7q-1.9-2.8-1.5-5.3 0.4-2.8 3-5.5c0.3 1.4 0.7 2.5 1.7 2.9 0.9 0.4 2.9 0 3.7-0.2 0.9-0.6 1.6-1.3 1.7-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m326 152.7c1 0.6 1.8 1.2 2.5 2.3 0.8 1.1 1.8 2.2 1.6 4.2-0.2 1.7-1.1 3.9-2.7 6.6-0.7-1-1.6-1.6-2.7-2-1.1-0.5-2.4-0.8-3.9-0.5-1.4 0.2-3.1 0.8-5 2-1.6-2.2-2.1-4.3-1.9-6.4 0.4-2.2 1.5-4.2 3.6-6.4q0.5 2.5 2.1 3.4c1.2 0.4 3.3 0.2 4.4-0.3 1.1-0.6 1.8-1.4 2-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m438.9 62.6l1.3 9.9c-44.8 2.1-82.2 3.7-114.5 5-32 1.2-47 1.2-76.6 2.5-29.5 1.4-73.4 3.6-99.5 5.7-25.8 2-39.2 3.9-54.9 6.7-15.5 2.7-28.4 6.5-37.8 10.4-9.1 3.9-13.1 8.6-17 13.4-3.9 4.6-3.2 9.9-6.2 15.2-2.9 5.2-6.7 16.4-10.9 16.2-3.9-0.5-9.8-10.6-13.2-18.1-3.1-7.7-4.6-17.9-6-26.9-1.3-9-2.3-17.8-2.4-26.7-0.3-9.7-0.2-19.1 0.3-28.5 0.6-9.4 0.9-19.6 2.9-27.2 2.1-7.6 6.3-15.5 9.4-18.1 3.1-2.5 6.3-0.3 9.1 2.9 2.8 3.1 5.5 11.5 7.6 15.8 2.1 4.3 1.2 6 4.7 9.8 3.5 3.9 5 9.5 16.1 13.3 11.2 3.8 24.7 6.9 50.2 9.2 25.7 2.3 68.9 3.4 102.2 4.5 33.3 1 56.6 1 96.1 1.9 39.6 0.8 85.2 1.8 139.1 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m279.7 31.3l0.8 2.8c2.1 0.6 4 1.6 6.3 3.4 2.3 1.6 5.8 4.1 6.9 6.9 1.2 2.9 1.1 6.8-0.3 9.8-1.4 2.8-2.8 5.4-8.4 7.2-5.7 1.8-13.8 2.8-25 3.3-0.3-1.4-1-2.6-2-3.4-1-0.8-2.4-1.5-4.1-1.8l-0.3-2c3.4 0 7.4 0.1 11.9 0.2 4.7 0 11.5 0.6 15.5 0 4-0.7 6.8-2.4 8.4-4.3 1.8-2 2.1-5.1 1.7-7.3-0.2-2.1-1.2-3.6-3.5-5.5-2.3-2.1-5.4-4.1-9.6-6.5-0.2-1.1-0.3-1.9-0.1-2.5 0.3-0.7 0.7-1.1 1-1.1 0.3-0.1 0.6 0.2 0.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m383.2 134.2h46v14.9h-46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m385.3 133.5c0.9 0.9 1.4 2.2 1.5 4.3 0.2 1.9 0 5.4-0.4 7.5q-0.5 3.1-1.7 4.6h-7.3l-1.6-0.9c-2.1-0.1-3.5-0.6-4.9-1.1-1-0.5-1.7-1.5-2.3-2.4-0.6-1.1-1.7-2.5-1.5-3.9 0.2-1.6 1-3.7 2.5-4.9 1.5-1.2 3.6-1.8 6.4-2.1l1.8-1.1c0 0 7.5 0 7.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m383.2 157.2h46v14.9h-46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m385.3 156.5c0.9 0.9 1.4 2.3 1.5 4.3 0.2 2 0 5.5-0.4 7.6q-0.5 3-1.7 4.6h-7.3l-1.6-0.9c-2.1-0.1-3.5-0.6-4.9-1.1-1-0.7-1.7-1.4-2.3-2.5-0.6-1.2-1.7-2.4-1.5-3.9 0.2-1.5 1-3.8 2.5-4.8 1.5-1.3 3.6-1.9 6.4-2.2l1.8-1.1c0 0 7.5 0 7.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m437.1 134.3c2.2-0.4 4.5-0.3 6.6 0.3 2.4 0.5 4.6 1.5 6.5 2.9 2.1 1.5 3.4 3.3 4.6 5.7 1.3 2.3 2.3 5.1 2.4 8.3 0.2 3.1-0.3 7.2-1.3 10-0.6 2.7-1.8 4.6-3.7 6.4-1.9 1.5-4.5 2.7-7.5 3.5-2.8 0.7-6 0.9-9.7 0.9l1.1-15.2c2.6 0.1 4.6-0.1 6-0.4 1.5-0.4 2.5-1.1 2.9-1.9 0.5-1 0.3-3.1-0.4-3.9-0.6-1-2.2-1.5-3.7-1.7-1.5-0.3-3.2-0.2-5.3 0.2 0.5-5 1-10.1 1.5-15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m437.9 133.5c1.2 0.9 1.9 2.2 2.1 4.3 0.4 1.9 0 5.4-0.5 7.5-0.5 2.1-1.3 3.6-2.4 4.6h-12c0 0 2.1-4 2.6-8 0.4-4.1-0.9-8.3-0.9-8.3 3.7 0 7.4-0.1 11.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m437.9 156.5c1.2 0.9 1.9 2.3 2.1 4.3 0.4 2 0 5.5-0.5 7.6-0.5 2-1.3 3.6-2.4 4.6h-12c0 0 2.1-4 2.6-8.1 0.4-4.1-0.9-8.2-0.9-8.2q5.6-0.1 11.2-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m356 134.3c2.5-0.4 5.1-0.3 7.5 0.3 2.5 0.5 5.3 1.5 7.3 2.9 2.2 1.5 3.9 3.3 5.2 5.7 1.5 2.3 2.5 5.1 2.6 8.3 0.3 3.1-0.3 7.2-1.4 10-0.8 2.7-2.1 4.6-4.2 6.4-2 1.5-5.1 2.7-8.4 3.5-3.2 0.7-6.8 0.9-10.9 0.9l1.2-15.2c2.9 0.1 5.1-0.1 6.8-0.4 1.7-0.4 2.7-1.1 3.2-1.9 0.5-1 0.3-3.1-0.4-3.9-0.8-1-2.4-1.5-4.2-1.7-1.7-0.3-3.6-0.2-5.9 0.2 0.5-5 1-10.1 1.6-15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m355.5 133.5c0.9 0.9 1.5 2.2 1.7 4.3 0.2 1.9 0.1 5.4-0.4 7.5-0.4 2.1-1 3.6-2 4.6h-8.1l-1.9-0.9c-2.2-0.1-4.1-0.6-5.4-1.1-1.3-0.5-2-1.5-2.7-2.4-0.7-1.1-1.8-2.5-1.7-3.9 0.3-1.6 1.1-3.7 2.8-4.9 1.8-1.2 4.2-1.8 7.3-2.1l2-1.1c0 0 8.4 0 8.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m355.5 156.5c0.9 0.9 1.5 2.3 1.7 4.3 0.2 2 0.1 5.5-0.4 7.6-0.4 2-1 3.6-2 4.6h-8.1l-1.9-0.9c-2.2-0.1-4.1-0.6-5.4-1.1-1.3-0.7-2-1.4-2.7-2.5-0.7-1.2-1.8-2.4-1.7-3.9 0.3-1.5 1.1-3.8 2.8-4.8 1.8-1.3 4.2-1.9 7.3-2.2l2-1.1c0 0 8.4 0 8.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m158 61.3h386v14.9h-386z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m159.6 153.1h139.8v14.9h-139.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m301.6 152l1.7 1.1c2.9 0.3 5 0.8 6.5 2.1 1.6 1.1 2.4 3.4 2.5 4.9 0.2 1.5-0.8 2.7-1.5 3.9-0.5 0.9-1.2 1.8-2.4 2.4-1.2 0.5-2.8 1-4.8 1.1l-1.7 1h-7.2c-0.8-1.2-1.4-2.6-1.8-4.7-0.2-2.1-0.5-5.5-0.4-7.5 0.2-2.1 0.7-3.4 1.5-4.3 0 0 7.6 0 7.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m152.4 75.8c-6.3-0.3-11.5 0.4-16.3 2.3-4.8 1.7-8.6 3.2-11.6 8.8-2.6 5.7-4.1 16.7-4.5 24.8-0.4 7.9 0.2 15.8 2.3 22.3 2.4 6.4 6.1 12.5 11.6 15.9 5.4 3.1 12 4.2 20.4 3.2l-2.2 14.7c-11.1-0.2-19.7-2.3-26.5-6.2-6.6-4-10.3-9.4-13.6-17.3-3.2-8.2-5.2-19.8-5.5-30.3-0.1-10.9 2.1-25 5-33.1 3.3-8 8.6-11.5 13.4-14.6 4.7-3.1 10.9-3.6 14.9-4.3 4.1-0.8 7.2-1 9.5-0.6 1 4.9 2.1 9.7 3.1 14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m160.9 60.7c0 0-1.4 4.2-0.9 8.3 0.4 4 2.7 8 2.7 8h-12.7c-1.1-1-1.9-2.5-2.5-4.5-0.4-2.2-0.8-5.7-0.5-7.6 0.3-2.1 1-3.4 2.1-4.3q5.9 0.1 11.8 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m160.9 152.4c0 0-1.4 4.2-0.9 8.2 0.4 4.1 2.7 8.1 2.7 8.1h-12.7c-1.1-1-1.9-2.5-2.5-4.6-0.4-2-0.8-5.6-0.5-7.5 0.3-2.1 1-3.4 2.1-4.3q5.9 0.1 11.8 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m167.8 75.1h8.3v14h-8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m167.8 140.1h8.3v14h-8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m169.9 88.7h4.8v52.6h-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m115.9 150.8c-0.7 0.9-1.5 1.6-2.5 2.1-0.8 0.4-1.8 0.7-2.9 0.7q-1.5 1.7 0.5 4.1 2.2 2.5 7.8 5.6-0.1-1.4 0.7-2c0.6-0.5 1.6-0.7 2.8-0.6l1-0.6 6.6 3.6-0.7 1.3q0.5 0.4 0.7 1.5c0.2 0.7 0.6 1.8 0.4 2.6-0.1 0.8-0.7 1.3-1.5 1.5-0.7 0-2-0.2-3.4-1.1q-3.8 1.6-9.2-1.5c-3.5-2.3-8.4-6.1-12-11.4-3.5-5.4-7.3-14.8-9.1-20-1.7-5.5-1.1-11-0.9-11.4 0.3-0.3 1 5.2 3 9.3 2.2 3.9 5.3 8.5 9.7 13.9 0.7-0.8 1.5-1.4 2.6-1.7q1.7-0.7 3.9-0.8 1.2 2.5 2.5 4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m430.6 66.1c27.5 0.7 87.7 4.3 86.8 4.9-1.3 0.3-66.4-1.4-92.6-1.8-25.8-0.4-30.8-1-61.5-0.4-30.8 0.4-100.2 3.2-121.3 3.1-20.5-0.2-15.2-2.6-2-3.6 13.5-1 62.6-1.9 81.8-2.2 19.1-0.6 14.3-0.5 32.4-0.5 18.4 0 49-0.5 76.4 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m210.4 163.8c-9.3-0.1-31.1-2.2-26.1-2.7 5.3-0.5 52-0.5 56.5 0 4.3 0.5-20.7 2.6-30.4 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m237 145.4c-9.5-0.1-31-2.2-26.2-2.7 5.4-0.5 52-0.5 56.5 0 4.3 0.5-20.6 2.6-30.3 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m405.4 145c-5.2-0.1-17-1.2-14.3-1.5 2.9-0.2 28.4-0.2 30.8 0 2.3 0.3-11.2 1.4-16.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m407 168.8c-5.2-0.1-16.8-1.3-14.2-1.5 2.9-0.2 28.4-0.2 30.8 0 2.4 0.2-11.3 1.4-16.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m281.8 105.4c7.1 0 12.8 6.1 12.8 13.7 0 7.6-5.7 13.8-12.8 13.8-7 0-12.7-6.2-12.7-13.8 0-7.6 5.7-13.7 12.7-13.7zm-10.9 13.7c0 6.6 4.8 11.8 10.8 11.8 6 0 10.8-5.2 10.8-11.8 0-6.5-4.8-11.8-10.8-11.8-6 0-10.8 5.3-10.8 11.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.146796bc9e76a81e5ea3c7b3bf8ebcb2.svg";
export { ForwardRef as ReactComponent };